// extracted by mini-css-extract-plugin
export default {"Root":"Page_Root__RaoxE","Error":"Page_Error__rL1O6","Loading":"Page_Loading__k8a15","SaveButtonRoot":"Page_SaveButtonRoot__ndKAC"};